import {
	tilerepoFightableMainEnemiesFrameNames,
	type FrameName,
} from "../config";
import { TileVisibilityType } from "../config/terrain";
import TileEntity from "../TileEntity";

abstract class AbstractSalvageableFightableEnemyTileEntity extends TileEntity {
	public static readonly frameName: FrameName;

	public get isMainEnemy(): boolean {
		return tilerepoFightableMainEnemiesFrameNames.has(this.frameName);
	}

	public get canStartSiege(): boolean {
		if (!this.range) return false;

		const neighbours =
			this.tilerepo.getNeighbourTileIndexesByTileCoordinates(
				{
					x: this.x,
					y: this.y,
				},
				this.range ?? 0,
				true,
				new Set<TileVisibilityType>([TileVisibilityType.EXPLORED]),
			);
		return neighbours.length === ((this.range ?? 0) * 2 + 1) ** 2;
	}
}

export default AbstractSalvageableFightableEnemyTileEntity;
